export default __webpack_public_path__ + "static/logo-91db9fb044bd02445b035939f339eee1.png";